<template>
  <div class="goods-detail-wrapper">
    <iframe :src="webUrl" frameborder="0" class="content-iframe"></iframe>
    <div class="btm-wrapper">
      <van-button @click="actionForHome" class="lf-btn" icon="wap-home-o" type="primary">商城首页</van-button>
      <van-button @click="actionForChange" class="rg-btn" type="default">我要兑换</van-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "GoodsDetail",
    data(){
      return{
        webUrl: ''
      }
    },
    methods: {
      //点击商城首页
      actionForHome() {
        this.$router.back({path:'/scoreShop'});
      },

      //点击我要兑换
      actionForChange() {
        const goodPrice = Number(this.$route.query.price);
        const curScore = this.$store.state.user.userInfo.rewardPoint;
        if (curScore >= goodPrice){
          this.$router.push({path: '/addressInfo',query: {rewardPointGoodsId: this.$route.query.rewardPointGoodsId}})
        }else {
          this.$toast({
            message: '当前积分不足',
            duration: 1000
          })
        }
      }
    },

    activated() {
      this.webUrl = this.$route.query.detailUrl;
      // this.webUrl = 'https://www.baidu.com';
    },
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .goods-detail-wrapper {
    box-sizing: border-box;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
  .content-iframe{
    width: 100%;
    flex: 1;
  }
  .btm-wrapper{
    height: 1.33333rem;
    display: flex;
    .lf-btn{
      background-color: #F7F7F7;
      border: 1px solid #F7F7F7;
      color: #000;
    }
    .rg-btn{
      flex: 1;
      background-color: #5597EC;
      color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// app/pages/tabs/ScoreShop/GoodsDetail.vue